import Vue from "vue";
import VueRouter from "vue-router";
import { routes } from "./routes";
import store from "../store";

Vue.use(VueRouter);

const router = new VueRouter({
  routes
});
router.onError((error) => {
  if (error.name === 'NavigationDuplicated') {
    console.log('Prevented navigation to the same page')
  } else {
    throw error
  }
})
const shipmentRegExp = /shipment\/\d+/i;

// router.beforeEach((to, from, next) => {
//   console.log("from", from, "to", to)
//   if (from.path == '/shipment/0') {
//     console.log("from", from, "to", to)
//     next({

//       replace: false
//     })
//   } else {
//     next();
//   }
// })

// router.beforeEach((to, from, next) => {
//   if (store.state.auth.isAuthenticated) {
//     console.log("Route guard -> Name:", to.name, "Path:", to.path);
//     if (
//       (to.name &&
//         store.getters["auth/permissions"].some(
//           permission => permission.toLowerCase() === to.name.toLowerCase()
//         )) ||
//       to.path === "/" ||
//       shipmentRegExp.test(to.path)
//     ) {
//       next();
//     } else {
//       next(false);
//       store.dispatch("notification/SHOW_ERROR", "Not allowed!");
//     }
//   } else {
//     next();
//     return;
//   }
// });

export default router;
